module.exports = __webpack_public_path__ + "static/paths_chronic_home-6a284dbe6db6029b6b20fe078fe96c7b.svg";